import { render, staticRenderFns } from "./UserAddAccount.vue?vue&type=template&id=0b03b20e&"
import script from "./UserAddAccount.vue?vue&type=script&lang=js&"
export * from "./UserAddAccount.vue?vue&type=script&lang=js&"
import style0 from "./UserAddAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports